import React, { useEffect, useState } from "react";
import Navigation from "../Navigation";
import $ from "jquery";
import NavigationPhone from "../NavigationPhone";
import "./style.css";

export default function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if ($(window).scrollTop() > 1) {
        $("body").addClass("Headerfixed");
        $(".headertwo").slideDown(300);
      } else {
        $("body").removeClass("Headerfixed");
        $(".headertwo").slideUp(300);
      }
    };
    $(window).on("scroll", handleScroll);
    return () => {
      $(window).off("scroll", handleScroll);
    };
  }, []); 
    return (
      <div className="mainheader">
        <header className={isNavOpen ? 'isopenmenu':''}>
            <div className="container">
            <NavigationPhone isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen}/>                          
            </div>
        </header>
        <div className="headertop d-flex">
        <div className="container">
            <Navigation />     
            </div>                 
          </div>
      </div>
    );
}
